import { SelectedItem } from './AIObjectPicker';

export interface AiLookupEntity {
  objectType: string;
  objectId: string;
}

export interface BuildAiLookupEntitiesOptions {
  /** Nav / prefs values override matching types in selectedObjects. */
  projectId?: string;
  projectVersionId?: string;
  /** When set, only these object types are included (e.g. active chat tab). */
  allowedObjectTypes?: string[];
}

export function normalizePrefId(raw: unknown): string {
  if (raw === undefined || raw === null || raw === '' || raw === 0) {
    return '';
  }
  const str = String(raw).trim();
  return str === '0' ? '' : str;
}

/**
 * Builds LookupEntities for FullAISearchResponse. Pref/nav scope overrides win over
 * stale selectedObjects so version changes in the header are always sent to the API.
 */
export function buildLookupEntitiesForAiRequest(
  selectedObjects: SelectedItem[],
  options: BuildAiLookupEntitiesOptions = {}
): AiLookupEntity[] {
  const { projectId, projectVersionId, allowedObjectTypes } = options;
  const allowed = allowedObjectTypes?.length
    ? new Set(allowedObjectTypes)
    : null;

  const byType = new Map<string, string>();

  for (const item of selectedObjects) {
    if (!item?.objectId || (allowed && !allowed.has(item.objectType))) {
      continue;
    }
    byType.set(item.objectType, item.objectId);
  }

  if (projectId) {
    byType.set('Project_Id', projectId);
  }
  if (projectVersionId) {
    byType.set('Project_Version_Id', projectVersionId);
  }

  return Array.from(byType.entries()).map(([objectType, objectId]) => ({
    objectType,
    objectId,
  }));
}
